/**
 * discount-drawer.js
 */
window.openOfferDrawer = function () {
  document.querySelector('#CartDrawer .drawer__inner')?.classList.add('overflow-hidden');
  document.querySelector('#DiscountDrawer')?.classList.add('active');
};

window.closeOfferDrawer = function () {
  document.querySelector('#CartDrawer .drawer__inner')?.classList.remove('overflow-hidden');
  document.querySelector('#DiscountDrawer')?.classList.remove('active');
};
(function () {
  'use strict';

  const DEFAULT_DISCOUNT_CODE = 'PURE10';
  const STORAGE_KEY = 'cd_active_code';
  const GENERIC_ERROR = 'Not eligible for this offer, or the code is invalid or has expired.';


  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // Best-effort money formatting: use the theme's own formatter if it's
  // around, otherwise fall back to Intl — no hard dependency either way.
  function formatMoney(cents, currencyCode) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && typeof Shopify.money_format === 'string') {
      try {
        return Shopify.formatMoney(cents, Shopify.money_format);
      } catch (e) {
        /* fall through */
      }
    }
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode || 'USD' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  // Cart subtotal in major units, excluding any variant that's wired up
  // as a gift on an offer card — discovered dynamically from whichever
  // cards exist right now, nothing hardcoded here.
  function cartSubtotalExcludingGifts(cart) {
    const giftVariantIds = new Set(
      Array.from(document.querySelectorAll('.cart-discount__apply-code[data-variant-id]')).map((el) => el.dataset.variantId)
    );
    const cents = (cart.items || []).reduce((sum, item) => {
      return giftVariantIds.has(String(item.variant_id)) ? sum : sum + item.original_line_price;
    }, 0);
    return cents / 100;
  }

  // Sets (or clears, with '') the active discount code. Optionally sets
  // line-item quantities in the SAME request via `updates`.
  async function setDiscount(code, updates) {
    const body = { discount: code };
    if (updates && Object.keys(updates).length) body.updates = updates;
    const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: JSON.stringify(body) });
    const cart = await response.json();
    return cart.errors ? null : cart;
  }

  // Line-item quantity changes only — omitting `discount` from the body
  // leaves whatever code is currently active untouched.
  async function setCartUpdates(updates) {
    const response = await fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({ updates }),
    });
    const cart = await response.json();
    return cart.errors ? null : cart;
  }


  async function refreshCartDrawer(openDrawer = false) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`,
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        }
      );

      if (!response.ok) throw new Error('Cart refresh failed');

      const sections = await response.json();

      // Update Cart Drawer
      if (sections['cart-drawer']) {
        const drawerHTML = new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html');

        const newDrawer = drawerHTML.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;

          currentDrawer.classList.toggle(
            'is-empty',
            newDrawer.classList.contains('is-empty')
          );
        }
      }

      // Update Cart Bubble
      if (sections['cart-icon-bubble']) {
        const bubbleHTML = new DOMParser()
          .parseFromString(sections['cart-icon-bubble'], 'text/html');

        const newBubble =
          bubbleHTML.querySelector('#cart-icon-bubble');

        const currentBubble =
          document.querySelector('#cart-icon-bubble');

        if (newBubble && currentBubble) {
          currentBubble.replaceWith(newBubble);
        }
      }
      document.getElementById('CartDrawer-Overlay')?.addEventListener('click', () => document.querySelector('cart-drawer').close());
      // Re-open drawer if required
      if (openDrawer) {
        const drawer = document.querySelector('cart-drawer');

        if (drawer) {
          drawer.open();
        }
      }

      return sections;

    } catch (error) {
      console.error('Cart drawer refresh error:', error);
    }
  }

  // Single source of truth for "what code is actually active" — always
  // derived from the real cart response, never assumed. Called on every
  // path that touches the cart's discount so sessionStorage can't drift
  // out of sync with what Shopify actually has attached (the old bug:
  // removing a code, or a failed apply, left sessionStorage pointing at
  // a code that was no longer really active).
  function syncActiveCodeStorage(cart) {
    const applicable = (cart.discount_codes || []).find((d) => d.applicable);
    if (applicable) {
      sessionStorage.setItem(STORAGE_KEY, applicable.code);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }

  // <cart-discount> lives outside the regions cart-drawer-items.onCartUpdate()
  // replaces, so it's never destroyed by this — it's safe to update its
  // badges directly, in parallel with Dawn's own item/footer refresh.
  //
  // `openDrawer` defaults to true because most callers are a direct result
  // of the user clicking something inside an already-open drawer. The
  // silent, page-load/background auto-apply path explicitly passes false —
  // it has no business popping the cart drawer open on its own.
  async function refreshDrawer(cart, openDrawer = true) {
    syncActiveCodeStorage(cart);
    await refreshCartDrawer(openDrawer);
    document.querySelector('cart-discount')?.renderBadges(cart);
  }

  function fireConfetti(originEl) {
    if (typeof launchConfettiFromButton === 'function') launchConfettiFromButton();
  }

  // ---- Auto-apply: empty -> non-empty gets the default code for free ----
  let autoApplyBusy = false;

  // Returns true if it actually changed the cart's discount (and already
  // refreshed the drawer for that), false if it left things untouched —
  // callers use this to know whether they still need to resync the UI
  // themselves against the cart they already have in hand.
  async function maybeAutoApply(cart) {
    if (!cart || cart.item_count === 0) {
      sessionStorage.removeItem(STORAGE_KEY);
      return false;
    }
    if (autoApplyBusy || sessionStorage.getItem(STORAGE_KEY)) return false;

    const existingCode = cart.discount_codes?.find((d) => d.applicable)?.code;
    if (existingCode) {
      // Already has a code (reload, another tab) — adopt it silently.
      sessionStorage.setItem(STORAGE_KEY, existingCode);
      return false;
    }

    autoApplyBusy = true;
    try {
      const updatedCart = await setDiscount(DEFAULT_DISCOUNT_CODE);
      if (!updatedCart) return false;

      const entry = (updatedCart.discount_codes || []).find(
        (d) => d.code.toLowerCase() === DEFAULT_DISCOUNT_CODE.toLowerCase()
      );
      if (!entry || !entry.applicable) return false;

      // false = don't force the drawer open; this runs silently on page
      // load / background cart updates, not from a click inside the drawer.
      refreshDrawer(updatedCart, false);
      fireConfetti();
      return true;
    } finally {
      autoApplyBusy = false;
    }
  }

  function checkCartForAutoApply(cartHint) {
    const cartPromise = cartHint && Array.isArray(cartHint.items)
      ? Promise.resolve(cartHint)
      : fetch('/cart.js').then((r) => r.json());

    cartPromise
      .then(async (cart) => {
        const didAutoApply = await maybeAutoApply(cart);
        if (!didAutoApply) {
          // Nothing changed via auto-apply, but the cart itself may have
          // changed for reasons entirely outside this file (a quantity
          // edit, a line-item removal, etc). Shopify silently flips a
          // previously-applied code's `applicable` flag to false when the
          // cart no longer qualifies — re-sync the badge + sessionStorage
          // against the real cart so a stale "still applied" badge never
          // lingers.
          syncActiveCodeStorage(cart);
          document.querySelector('cart-discount')?.renderBadges(cart);
        }
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    // checkCartForAutoApply(); // catches any mismatch already on the page

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cart = event?.cartData && Array.isArray(event.cartData.items) ? event.cartData : undefined;
        // checkCartForAutoApply(cart);
      });
    }
  });

  // ---- <cart-discount>: manual apply/remove UI ----

  class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('#CartDrawer-DiscountInput');
      this.submitButton = this.querySelector('#CartDrawer-DiscountSubmit');
      this.errorElement = this.querySelector('#CartDrawer-DiscountError');
      this.badgesElement = this.querySelector('#CartDrawer-DiscountBadges');
      this.isBusy = false;

      this.addEventListener('click', (event) => {
        const removeButton = event.target.closest('.cart-discount__badge-remove');
        if (removeButton) {
          event.preventDefault();
          this.remove(removeButton.closest('.cart-discount__badge').dataset.code);
          return;
        }

        const cardButton = event.target.closest('.cart-discount__apply-code[data-code]');
        if (cardButton) {
          event.preventDefault();
          this.apply(cardButton.dataset.code, cardButton);
          return;
        }

        if (event.target.closest('#CartDrawer-DiscountSubmit')) {
          event.preventDefault();
          this.apply(this.input?.value.trim(), this.submitButton);
        }
      });

      this.input?.addEventListener('keydown', (event) => {
        if (event.code === 'Enter') {
          event.preventDefault();
          this.apply(this.input.value.trim(), this.submitButton);
        }
      });
    }

    // Note: no connectedCallback badge-seeding anymore — the initial
    // badge state is server-rendered by Liquid, so there's nothing to
    // reconstruct client-side on first paint.

    giftVariantForCode(code) {
      if (!code) return null;
      const btn = this.querySelector(`.cart-discount__apply-code[data-code="${CSS.escape(code)}"]`);
      return btn?.dataset.variantId || null;
    }

    getAppliedCodes() {
      return Array.from(this.badgesElement?.querySelectorAll('.cart-discount__badge') || []).map((el) => el.dataset.code);
    }

    buildNotQualifiedMessage(minSubtotal, cart) {
      if (minSubtotal && cart) {
        const shortfall = minSubtotal - cartSubtotalExcludingGifts(cart);
        if (shortfall > 0) {
          return `Add ${formatMoney(Math.round(shortfall * 100), cart.currency)} more to avail this offer.`;
        }
      }
      return GENERIC_ERROR;
    }

    async apply(code, originEl) {
      if (!code || this.isBusy) return;
      this.isBusy = true;
      this.clearError();
      this.setLoading(true);

      const isCardButton = !!originEl?.classList.contains('cart-discount__apply-code');
      const targetVariantId = isCardButton ? originEl.dataset.variantId || null : null;
      const minSubtotal = isCardButton && originEl.dataset.minSubtotal ? Number(originEl.dataset.minSubtotal) : null;
      const previousCode = this.getAppliedCodes()[0] || null;

      try {
        let cart = await setDiscount(code);
        if (!cart) {
          this.showError(isCardButton ? this.buildNotQualifiedMessage(minSubtotal, null) : GENERIC_ERROR);
          return;
        }

        const entry = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());

        if (!entry || !entry.applicable) {
          // setDiscount() above already overwrote whatever code was
          // previously active on the cart with this new, ineligible one —
          // Shopify attaches a code to the cart regardless of eligibility.
          // Put the cart back the way it was (the previous valid code, or
          // none) instead of silently leaving an inapplicable code on the
          // cart while the drawer keeps showing the OLD badge as if it
          // were still applied.
          const revertTo = previousCode && previousCode.toLowerCase() !== code.toLowerCase() ? previousCode : '';
          const revertedCart = await setDiscount(revertTo);
          if (revertedCart) refreshDrawer(revertedCart);
          this.showError(isCardButton ? this.buildNotQualifiedMessage(minSubtotal, cart) : GENERIC_ERROR);
          return;
        }

        // Discount is confirmed live — only now do we touch cart items,
        // so a rejected/ineligible code never adds or removes anything.
        const previousVariantId = previousCode ? this.giftVariantForCode(previousCode) : null;
        const giftUpdates = {};
        if (previousVariantId && previousVariantId !== targetVariantId) giftUpdates[previousVariantId] = 0;
        if (targetVariantId) giftUpdates[targetVariantId] = 1;
        if (Object.keys(giftUpdates).length) {
          const withGift = await setCartUpdates(giftUpdates);
          if (withGift) cart = withGift;
        }

        if (!isCardButton) this.input.value = '';
        refreshDrawer(cart);

        // Any successful manual apply gets confetti — including PURE10,
        // which previously was silently excluded here.
        launchConfettiFromButton(originEl);
        window.closeOfferDrawer();
      } catch (err) {
        this.showError(isCardButton ? this.buildNotQualifiedMessage(minSubtotal, null) : GENERIC_ERROR);
        console.error('Discount apply failed:', err);
      } finally {
        this.isBusy = false;
        this.setLoading(false);
      }
    }

    async remove(code) {
      if (!code || this.isBusy) return;
      this.isBusy = true;

      const variantId = this.giftVariantForCode(code);

      try {
        const cart = await setDiscount('', variantId ? { [variantId]: 0 } : undefined);
        if (cart) refreshDrawer(cart);
      } catch (err) {
        console.error('Discount remove failed:', err);
      } finally {
        this.isBusy = false;
      }
    }

    renderBadges(cart) {
      if (!this.badgesElement) return;
      const codes = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
      this.badgesElement.innerHTML = codes
        .map(
          (code) => `
            <span class="cart-discount__badge" data-code="${escapeHtml(code)}">
              ${escapeHtml(code)}
              <button type="button" class="cart-discount__badge-remove" aria-label="Remove ${escapeHtml(code)}">&times;</button>
            </span>`
        )
        .join('');
    }

    setLoading(isLoading) {
      this.submitButton?.toggleAttribute('disabled', isLoading);
      this.submitButton?.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      this.submitButton?.querySelector('.cart-discount__submit-text')?.classList.toggle('hidden', isLoading);
    }

    showError(message) {
      if (!this.errorElement) return;
      this.errorElement.textContent = message;
      this.errorElement.hidden = false;
    }

    clearError() {
      if (!this.errorElement) return;
      this.errorElement.textContent = '';
      this.errorElement.hidden = true;
    }
  }

  customElements.define('cart-discount', CartDiscount);
})();